import React from 'react';
import Toggle from 'react-toggle';
import { Field, useFormikContext } from 'formik';

const ToggleButtonField = ({ id, label, name, options }) => {
  const { initialValues, setFieldValue, value } = useFormikContext();
  return (
    <>
      <div className="facet-filters__input">
        <Field type="checkbox" name={name} id={id} className={'sqz-visuallyhidden'} value={value} />
        <label className="facet-filters__input--toggle">
          <span>{label}</span>
          <Toggle
            defaultChecked={initialValues[name]?.toString() === 'true'}
            icons={false}
            name={name}
            onChange={(e) => {
              setFieldValue(name, e.target.checked ? options[0].value : options[1].value);
            }}
          />
        </label>
      </div>
    </>
  );
};

export default ToggleButtonField;
